import { useEffect, useState } from 'react';
import { theme } from '../../theme';
import MessageThread from './MessageThread';
import { useIsMobile } from '../../hooks/useMediaQuery';

export default function MessageHistoryModal({ conv, token, onClose }) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!conv) return;
    fetch(`/api/agent/conversations/${conv.id}/messages`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then((data) => { setMessages(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [conv, token]);

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 300,
      padding: isMobile ? '1rem' : 0,
    }}>
      <div style={{
        background: theme.colors.surface, borderRadius: '12px',
        border: `1px solid ${theme.colors.border}`,
        width: isMobile ? '100%' : '560px', maxWidth: '560px',
        maxHeight: '80vh', display: 'flex', flexDirection: 'column', boxSizing: 'border-box',
      }}>
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '1rem 1.5rem', borderBottom: `1px solid ${theme.colors.border}`,
        }}>
          <span style={{ color: theme.colors.primary, fontWeight: 600 }}>
            Historial — {conv?.owner}
          </span>
          <button onClick={onClose} style={{
            background: 'transparent', border: 'none', color: theme.colors.textMuted,
            cursor: 'pointer', fontSize: '1.2rem',
          }}>✕</button>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
          {loading
            ? <div style={{ padding: '2rem', textAlign: 'center', color: theme.colors.textMuted }}>Cargando...</div>
            : <MessageThread messages={messages} />
          }
        </div>
      </div>
    </div>
  );
}
